import React from 'react';
import classnames from 'classnames';
import { MessagePropertiesContext } from '../../../../../contexts/messageProperties';
import getSelectedVariantName from '../../utils/getSelectedVariant';
import styles from './link.module.pcss';

interface LinkProps {
  href: string;
}

export const PRODUCT_DIMENSION_KEY = 'size';

function Link({ href }: LinkProps): React.ReactElement {
  const [formattedMessage] = React.useContext(MessagePropertiesContext);
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    const selectedVariant = getSelectedVariantName();
    window.location.href = `${href}${selectedVariant ? `?${PRODUCT_DIMENSION_KEY}=${selectedVariant}` : ''}`;
  };

  return (
    <div>
      <a href={href} onClick={handleClick} className={classnames(styles.link, 'button--tertiary')}>
        {formattedMessage({ id: 'product.other.styles.link', fallback: 'View' })}
      </a>
    </div>
  );
}

export default Link;
